module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.error) ? _c('p', {
    staticClass: "alert alert-danger margin-t30 margin-b10"
  }, [_c('b', [_vm._v("Atenção!")]), _vm._v(" Não é possível cadastrar agregado com o mesmo CNPJ do\n    agregador.\n  ")]) : _c('p', {
    staticClass: "alert alert-warning margin-t30 margin-b10"
  }, [_c('b', [_vm._v("Atenção!")]), _vm._v(" Certifique-se de ter em mãos todos os dados para o\n    cadastro.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('taxIdNumber')
    }
  }, [_c('label', {
    attrs: {
      "for": "taxIdNumber"
    }
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.taxIdNumberFormatted),
      expression: "taxIdNumberFormatted",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:18|cnpj'),
      expression: "'required|max:18|cnpj'"
    }, {
      name: "mask-cnpj",
      rawName: "v-mask-cnpj"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2})$",
      "name": "taxIdNumber",
      "value": "",
      "data-vv-validate-on": "blur"
    },
    domProps: {
      "value": (_vm.taxIdNumberFormatted)
    },
    on: {
      "blur": function($event) {
        return _vm.companyExists()
      },
      "change": function($event) {
        _vm.taxIdNumberFormatted = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n      " + _vm._s(_vm.errors.first("taxIdNumber")) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('company-name')
    }
  }, [_c('label', {
    attrs: {
      "for": "company-name"
    }
  }, [_vm._v("Razão social")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyName),
      expression: "companyName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:100'),
      expression: "'required|max:100'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "company-name",
      "value": ""
    },
    domProps: {
      "value": (_vm.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n      " + _vm._s(_vm.errors.first("company-name")) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('company-trade-name')
    }
  }, [_c('label', {
    attrs: {
      "for": "company-trade-name"
    }
  }, [_vm._v("Nome fantasia")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyTradeName),
      expression: "companyTradeName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:100'),
      expression: "'required|max:100'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "company-trade-name",
      "value": ""
    },
    domProps: {
      "value": (_vm.companyTradeName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyTradeName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n      " + _vm._s(_vm.errors.first("company-trade-name")) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "contact-box"
  }, [_c('p', {
    staticClass: "aggregate-sub"
  }, [_vm._v("Contato")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n        " + _vm._s(_vm.errors.first("email")) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('celular')
    }
  }, [_c('label', {
    attrs: {
      "for": "celular"
    }
  }, [_vm._v("Telefone celular")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask-tel",
      rawName: "v-mask-tel"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.cel),
      expression: "cel",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|cell'),
      expression: "'required|cell'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "celular",
      "name": "celular",
      "title": "celular",
      "data-vv-validate-on": "blur",
      "maxlength": "14"
    },
    domProps: {
      "value": (_vm.cel)
    },
    on: {
      "input": _vm.correctCursor2,
      "change": function($event) {
        _vm.cel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n        " + _vm._s(_vm.errors.first("celular")) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask-tel",
      rawName: "v-mask-tel"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.tel),
      expression: "tel",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('phone'),
      expression: "'phone'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "telefone",
      "name": "telefone",
      "title": "telefone",
      "data-vv-validate-on": "blur",
      "maxlength": "14"
    },
    domProps: {
      "value": (_vm.tel)
    },
    on: {
      "input": _vm.correctCursor2,
      "change": function($event) {
        _vm.tel = $event.target.value
      }
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Telefone fixo "), _c('span', [_vm._v("(opcional)")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-7f70f35c!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/aggregate/modal/aggregate-register/company.vue
// module id = 2184
// module chunks = 1